/**
 * @generated SignedSource<<304fb862db7edbc16d36bc8a5491fc8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavingsPlanStatus = "ACTIVE" | "CANCELED";
export type SavingsPlansInput = {
  after?: string | null | undefined;
  assetId?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  savingsPlanId?: string | null | undefined;
  status?: SavingsPlanStatus | null | undefined;
};
export type CountSavingsPlansViewQuery$variables = {
  input?: SavingsPlansInput | null | undefined;
};
export type CountSavingsPlansViewQuery$data = {
  readonly savingsPlans: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type CountSavingsPlansViewQuery = {
  response: CountSavingsPlansViewQuery$data;
  variables: CountSavingsPlansViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SavingsPlansConnection",
    "kind": "LinkedField",
    "name": "savingsPlans",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CountSavingsPlansViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CountSavingsPlansViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5b073eabc93d1d6dd576c3982d523844",
    "id": null,
    "metadata": {},
    "name": "CountSavingsPlansViewQuery",
    "operationKind": "query",
    "text": "query CountSavingsPlansViewQuery(\n  $input: SavingsPlansInput\n) {\n  savingsPlans(input: $input) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a6c4aa363dfb5bea94b66c8b839e81d";

export default node;
